export const style = {
  containerSx: {
    px: 5,
    pb: 5,
    mt: 10,
    width: 1,
    display: 'block',
    textAlign: 'center',
  },
  stackSx: { mt: 1.5, mb: 2 },
  textSecondarySx: { color: 'text.secondary', whiteSpace: 'pre-line' },
};
